export const INBOX_CAP_CELLS = 6

export function cellsForSize(size: string): number {
  return size === "md" ? 2 : 1
}

export function remainingCells(tiles: { size: string }[]): number {
  return Math.max(0, INBOX_CAP_CELLS - tiles.reduce((sum, t) => sum + cellsForSize(t.size), 0))
}

export function fitsInRemaining(size: string, remaining: number): boolean {
  return cellsForSize(size) <= remaining
}

/** The inbox grid only has sm/md; anything else (a persisted or proposed `lg`) clamps down. */
export function clampToInboxSize(size?: string): "sm" | "md" {
  return size === "md" ? "md" : "sm"
}
